import { useEffect, useState, type ReactNode } from 'react';
import { entrar, nivelAtual } from '../lib/auth.js';
import { Logo } from './Logo.js';

/**
 * Portao de senha. Pergunta ao SERVIDOR se ja existe sessao (cookie) e, se nao,
 * pede a senha e manda conferir la. Vale ate o fim do dia.
 *
 * `bypass` libera sem senha — usado quando o movel foi aberto pelo QR (peca
 * escaneada). Nao e mais so visual: o servidor tambem so entrega os moveis
 * daquela peca.
 */
export function PasswordGate({ bypass = false, children }: { bypass?: boolean; children: ReactNode }) {
  const [estado, setEstado] = useState<'verificando' | 'livre' | 'pedir'>(bypass ? 'livre' : 'verificando');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [ver, setVer] = useState(false);
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    if (bypass) return;
    let vivo = true;
    nivelAtual().then((n) => { if (vivo) setEstado(n ? 'livre' : 'pedir'); });
    return () => { vivo = false; };
  }, [bypass]);

  if (estado === 'livre') return <>{children}</>;
  if (estado === 'verificando') {
    return <div className="gate"><div className="spinner" /></div>;
  }

  async function aoEnviar(e: React.FormEvent) {
    e.preventDefault();
    if (!senha.trim() || enviando) return;
    setEnviando(true);
    const r = await entrar(senha.trim());
    setEnviando(false);
    if (r.ok) { setEstado('livre'); return; }
    setErro(
      r.motivo === 'bloqueado' ? 'Muitas tentativas. Aguarde 15 minutos.'
        : r.motivo === 'rede' ? 'Sem conexão com o servidor.'
        : 'Senha incorreta.',
    );
  }

  return (
    <div className="gate">
      <form className="gate-card" onSubmit={aoEnviar}>
        <div className="gate-logo"><Logo size={40} /></div>
        <div className="muted small" style={{ textAlign: 'center' }}>Acesso restrito — informe a senha</div>
        <div className="gate-input">
          <input
            type={ver ? 'text' : 'password'}
            placeholder="Senha"
            value={senha}
            autoComplete="current-password"
            onChange={(e) => { setSenha(e.target.value); setErro(''); }}
          />
          <button
            type="button"
            className="gate-eye"
            onClick={() => setVer((s) => !s)}
            aria-label={ver ? 'Ocultar senha' : 'Mostrar senha'}
            title={ver ? 'Ocultar senha' : 'Mostrar senha'}
          >
            {ver ? '🙈' : '👁️'}
          </button>
        </div>
        {erro && <div className="error-box small">{erro}</div>}
        <button type="submit" className="primary" disabled={enviando}>{enviando ? 'Conferindo…' : 'Entrar'}</button>
        <div className="muted small" style={{ textAlign: 'center' }}>Pedida 1x por dia neste aparelho.</div>
      </form>
    </div>
  );
}
